/* Тост с необязательным действием («Отменить», «Вернуть») — общий для всего кабинета.
   Вызов как в прототипе: toast(text) или toast(text, 'Отменить', () => …).
   Один тост на экране: новый заменяет старый. С действием живёт дольше —
   на отмену нужно успеть подумать. <ToastHost/> ставится один раз в корне. */
import { useEffect, useState, useSyncExternalStore } from 'react';

interface T {
  id: number;
  text: string;
  action?: string;
  onAction?: () => void;
}
let cur: T | null = null;
let seq = 0;
let timer: ReturnType<typeof setTimeout> | undefined;
const subs = new Set<() => void>();
const emit = () => subs.forEach((f) => f());

export function toast(text: string, action?: string, onAction?: () => void) {
  clearTimeout(timer);
  cur = { id: ++seq, text, action, onAction };
  emit();
  const id = cur.id;
  timer = setTimeout(() => dismiss(id), action ? 6000 : 2600);
}
function dismiss(id?: number) {
  if (cur && (id == null || cur.id === id)) {
    cur = null;
    emit();
  }
}

export function ToastHost() {
  const t = useSyncExternalStore(
    (f) => {
      subs.add(f);
      return () => subs.delete(f);
    },
    () => cur,
  );
  /* Появление — на следующий кадр, чтобы сработал переход .on */
  const [shown, setShown] = useState<number | null>(null);
  useEffect(() => {
    if (!t) return;
    const r = requestAnimationFrame(() => setShown(t.id));
    return () => cancelAnimationFrame(r);
  }, [t]);
  if (!t) return null;
  return (
    <div className={'toast' + (shown === t.id ? ' on' : '')} key={t.id}>
      <span>{t.text}</span>
      {t.action && (
        <button
          className="undo"
          onClick={() => {
            const f = t.onAction;
            dismiss(t.id);
            f?.();
          }}
        >
          {t.action}
        </button>
      )}
    </div>
  );
}
